import {ChangeDetectionStrategy, Component} from '@angular/core';
import { NgbCarousel, NgbSlide } from '@ng-bootstrap/ng-bootstrap';
import { PromotionNotificationComponent } from '../promotion-notification/promotion-notification.component';
import { RouterLink } from '@angular/router';
import {NgOptimizedImage} from '@angular/common';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    imports: [RouterLink, PromotionNotificationComponent, NgbCarousel, NgbSlide, NgOptimizedImage],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AboutComponent {

}
